import axios from "axios"
import { ElMessage } from "element-plus"

// 导出
export const downLoad = (url, params, name) => {
    let token = localStorage.getItem('token')
    axios({
      // url:'http://192.168.2.14:8086/'+url, // 根据需求自己改
      url:'https://wx.yixiankeji.com/'+url,
      method: 'get', // 根据需求自己改
      headers: {
        'Content-Type': 'application/json',
        authorization : token
      },
      params: params,
      responseType: 'blob'
    }).then((res) => {
      // 生成下载URL
      const url = window.URL.createObjectURL(new Blob([res.data]), {
        type: 'application/vnd.ms-excel',
        'charset': 'utf-8',
        'content-type': 'application/octet-stream'
      })
      // 创建隐藏的a标签用于自动下载导出文件
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', name + '.xlsx')
      document.body.appendChild(link)
      link.click()
      ElMessage({
        message: '导出成功',
        type: 'success',
        duration: 5 * 1000
      })
    }, (err) => {
        if(err){
            ElMessage({
                message: '导出失败',
                type: 'error',
                duration: 5 * 1000
              })
        }
    })
  }